<template>
  <div>
    <!-- Video -->
    <video-view video-id="https://vimeo.com/625577468/47d3ed3bf5">
      <!-- Title (first) -->
      <template slot="title-first">
        <div>
          {{ $t('header_4_1') }}
          <div class="underline">
            {{ $t('header_4_2') }}
          </div>
        </div>
      </template>

      <!-- Video -->
      <video
        autoplay
        muted
        loop
        playsinline
      >

        <source
          type="video/mp4"
          src="https://media.blissapplications.com/videos/desktop-1440-clip-home.mp4"
        >

      </video>
    </video-view>

    <!-- Info -->
    <info-view />

    <!-- Services -->
    <services-view />

    <!-- Handoff -->
    <handoff-view />

    <!-- Footer -->
    <footer-contact-view />
    <footer-location-view />
    <footer-awards-view />
    <footer-portugal-2020-view />
    <footer-follow-view />
  </div>
</template>

<script>

export default {
  name: 'PageHome',

  components: {
    InfoView: () => import('@/components/info/info-view'),
    FooterAwardsView: () => import('@/components/footer/footer-awards-view'),
    FooterContactView: () => import('@/components/footer/footer-contact-view'),
    FooterFollowView: () => import('@/components/footer/footer-follow-view'),
    FooterLocationView: () => import('@/components/footer/footer-location-view'),
    FooterPortugal2020View: () => import('@/components/footer/footer-portugal-2020-view'),
    HandoffView: () => import('@/components/handoff/handoff-view'),
    ServicesView: () => import('@/components/services/services-view'),
    VideoView: () => import('@/components/video/video-view')
  },

  metaInfo: {
    title: 'Bliss Applications: User-centered design company',
    meta: [
      {
        name: 'description',
        content: 'Bliss Applications is a software developer based in Portugal & Boston specializing in mobile apps for start-ups, consumer marketing & enterprise tools.'
      },
      {
        property: 'og:url',
        content: 'https://www.blissapplications.com/'
      },
      {
        property: 'og:title',
        content: 'Bliss Applications: User-centered design company'
      },
      {
        property: 'og:description',
        content: 'Bliss Applications is a software developer based in Portugal & Boston specializing in mobile apps for start-ups, consumer marketing & enterprise tools.'
      },
      {
        property: 'og:image',
        content: 'https://drive.google.com/file/d/135aIMh5U9N4BSuF0mYkaRy2nx6LCpq1h/view?usp=sharing'
      },
      {
        name: 'twitter:title',
        content: 'Bliss Applications: User-centered design company'
      },
      {
        name: 'twitter:description',
        content: 'Bliss Applications is a software developer based in Portugal & Boston specializing in mobile apps for start-ups, consumer marketing & enterprise tools.'
      },
      {
        name: 'twitter:image',
        content: 'https://drive.google.com/file/d/135aIMh5U9N4BSuF0mYkaRy2nx6LCpq1h/view?usp=sharing'
      }
    ]
  }
};
</script>



// WEBPACK FOOTER //
// home.vue